import { API } from "aws-amplify";
import { SITE_VIEW } from "constants/unit";
import { constructStatusQueryString } from "utils/actions";
import { getUnitDetails } from "./unit";
import { getDatatableFilters, SITE_FILTERS_KEY } from "utils/localStorage";

export const GET_SITE_LIST_REQUEST = "@@site/GET_SITE_LIST_REQUEST";
export const GET_SITE_LIST_SUCCESS = "@@site/GET_SITE_LIST_SUCCESS";
export const GET_SITE_LIST_FAILURE = "@@site/GET_SITE_LIST_FAILURE";

export function getSiteList(formData = undefined) {
  return async (dispatch) => {
    dispatch({
      type: GET_SITE_LIST_REQUEST,
    });
    try {
      let url = "/site?fields=nmi,units";
      if (formData) {
        url = constructStatusQueryString(url, formData);
      }

      const response = await API.get("cmsAPI", url);

      dispatch({
        type: GET_SITE_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SITE_FILTER_LIST_REQUEST =
  "@@site/GET_SITE_FILTER_LIST_REQUEST";
export const GET_SITE_FILTER_LIST_SUCCESS =
  "@@site/GET_SITE_FILTER_LIST_SUCCESS";
export const GET_SITE_FILTER_LIST_FAILURE =
  "@@site/GET_SITE_FILTER_LIST_FAILURE";

export function getSiteFilterList(formData = undefined) {
  return async (dispatch) => {
    dispatch({
      type: GET_SITE_FILTER_LIST_REQUEST,
    });
    try {
      let url = "/site";
      if (formData) {
        url = constructStatusQueryString(url, {
          ...formData,
          limit: formData?.view === SITE_VIEW.MAP ? null : formData.limit,
          offset: formData?.view === SITE_VIEW.MAP ? null : formData.offset,
          view: null,
        });
      }

      let response = await API.get("cmsAPI", url);

      if (formData.view === SITE_VIEW.MAP) {
        response = {
          total_count: response.length,
          items: response,
        };
      }

      const values = getDatatableFilters(SITE_FILTERS_KEY);
      if (formData.search === values.search) {
        dispatch({
          type: GET_SITE_FILTER_LIST_SUCCESS,
          payload: response,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_SITE_FILTER_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SITE_DETAILS_REQUEST = "@@site/GET_SITE_DETAILS_REQUEST";
export const GET_SITE_DETAILS_SUCCESS = "@@site/GET_SITE_DETAILS_SUCCESS";
export const GET_SITE_DETAILS_FAILURE = "@@site/GET_SITE_DETAILS_FAILURE";

export function getSiteDetails(id) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_SITE_DETAILS_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/site/${id}`);
      dispatch({
        type: GET_SITE_DETAILS_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_DETAILS_FAILURE,
        payload: error,
      });
    }
  };
}

export const PUT_SITE_REQUEST = "@@site/PUT_SITE_REQUEST";
export const PUT_SITE_SUCCESS = "@@site/PUT_SITE_SUCCESS";
export const PUT_SITE_FAILURE = "@@site/PUT_SITE_FAILURE";

export function updateSite(id, formData) {
  return async (dispatch) => {
    if (!id) return;

    dispatch({
      type: PUT_SITE_REQUEST,
    });
    const init = {
      body: formData,
    };
    try {
      const response = await API.put("cmsAPI", `/site/${id}`, init);
      dispatch({
        type: PUT_SITE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: PUT_SITE_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_SITE_DETAILS = "@@site/CLEAR_SITE_DETAILS";

export function clearSiteDetails() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_SITE_DETAILS,
    });
  };
}

export const GET_SITE_EVENTS_LIST_REQUEST =
  "@@site/GET_SITE_EVENTS_LIST_REQUEST";
export const GET_SITE_EVENTS_LIST_SUCCESS =
  "@@site/GET_SITE_EVENTS_LIST_SUCCESS";
export const GET_SITE_EVENTS_LIST_FAILURE =
  "@@site/GET_SITE_EVENTS_LIST_FAILURE";

export function getSiteEventsList(site) {
  return async (dispatch) => {
    if (!site) return;
    dispatch({
      type: GET_SITE_EVENTS_LIST_REQUEST,
    });
    try {
      let url = `/event?site=${site}`;
      const response = await API.get("cmsAPI", url);
      dispatch({
        type: GET_SITE_EVENTS_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_EVENTS_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SITE_OPTIMISATION_STRATEGY_REQUEST =
  "@@site/GET_SITE_OPTIMISATION_STRATEGY_REQUEST";
export const GET_SITE_OPTIMISATION_STRATEGY_SUCCESS =
  "@@site/GET_SITE_OPTIMISATION_STRATEGY_SUCCESS";
export const GET_SITE_OPTIMISATION_STRATEGY_FAILURE =
  "@@site/GET_SITE_OPTIMISATION_STRATEGY_FAILURE";

export function getSiteOptimisationStrategy(id) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_SITE_OPTIMISATION_STRATEGY_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/site/${id}/optimisation_strategy`,
      );
      dispatch({
        type: GET_SITE_OPTIMISATION_STRATEGY_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_OPTIMISATION_STRATEGY_FAILURE,
        payload: error,
      });
    }
  };
}

export const PUT_SITE_OPTIMISATION_STRATEGY_REQUEST =
  "@@site/PUT_SITE_OPTIMISATION_STRATEGY_REQUEST";
export const PUT_SITE_OPTIMISATION_STRATEGY_SUCCESS =
  "@@site/PUT_SITE_OPTIMISATION_STRATEGY_SUCCESS";
export const PUT_SITE_OPTIMISATION_STRATEGY_FAILURE =
  "@@site/PUT_SITE_OPTIMISATION_STRATEGY_FAILURE";

export function updateOptimisationStrategy(id, formData, callback) {
  return async (dispatch) => {
    if (!id) return;

    dispatch({
      type: PUT_SITE_OPTIMISATION_STRATEGY_REQUEST,
    });
    const init = {
      body: formData,
    };
    try {
      const response = await API.put(
        "cmsAPI",
        `/site/${id}/optimisation_strategy`,
        init,
      );
      dispatch({
        type: PUT_SITE_OPTIMISATION_STRATEGY_SUCCESS,
        payload: response,
      });

      dispatch(getSiteOptimisationStrategy(id));
      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: PUT_SITE_OPTIMISATION_STRATEGY_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_RESTRICTED_DOCUMENT_LIST_REQUEST =
  "@@site/GET_RESTRICTED_DOCUMENT_LIST_REQUEST";
export const GET_RESTRICTED_DOCUMENT_LIST_SUCCESS =
  "@@site/GET_RESTRICTED_DOCUMENT_LIST_SUCCESS";
export const GET_RESTRICTED_DOCUMENT_LIST_FAILURE =
  "@@site/GET_RESTRICTED_DOCUMENT_LIST_FAILURE";

export function getOwnerRestrictedDocumentList(siteId) {
  return async (dispatch) => {
    dispatch({
      type: GET_RESTRICTED_DOCUMENT_LIST_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/site/${siteId}/owner_restricted_document`,
      );

      dispatch({
        type: GET_RESTRICTED_DOCUMENT_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_RESTRICTED_DOCUMENT_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const DELETE_RESTRICTED_DOCUMENT_REQUEST =
  "@@site/DELETE_RESTRICTED_DOCUMENT_REQUEST";
export const DELETE_RESTRICTED_DOCUMENT_SUCCESS =
  "@@site/DELETE_RESTRICTED_DOCUMENT_SUCCESS";
export const DELETE_RESTRICTED_DOCUMENT_FAILURE =
  "@@site/DELETE_RESTRICTED_DOCUMENT_FAILURE";

export function deleteOwnerRestrictedDocument(siteId, user, file_name) {
  return async (dispatch) => {
    dispatch({
      type: DELETE_RESTRICTED_DOCUMENT_REQUEST,
    });
    try {
      const response = await API.del(
        "cmsAPI",
        `/site/${siteId}/owner_restricted_document?user=${user}&file_name=${file_name}`,
      );

      dispatch({
        type: DELETE_RESTRICTED_DOCUMENT_SUCCESS,
        payload: response,
      });
      dispatch(getOwnerRestrictedDocumentList(siteId));
    } catch (error) {
      dispatch({
        type: DELETE_RESTRICTED_DOCUMENT_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_ENERGY_USAGE_PLAN_REQUEST =
  "@@site/GET_ENERGY_USAGE_PLAN_REQUEST";
export const GET_ENERGY_USAGE_PLAN_SUCCESS =
  "@@site/GET_ENERGY_USAGE_PLAN_SUCCESS";
export const GET_ENERGY_USAGE_PLAN_FAILURE =
  "@@site/GET_ENERGY_USAGE_PLAN_FAILURE";

export function getEnergyUsagePlan(id, start) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_ENERGY_USAGE_PLAN_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/site/${id}/energy-usage-plan?start=${start}`,
      );
      dispatch({
        type: GET_ENERGY_USAGE_PLAN_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_ENERGY_USAGE_PLAN_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_ENERGY_USAGE_PLAN_DESCRIPTION_REQUEST =
  "@@site/GET_ENERGY_USAGE_PLAN_DESCRIPTION_REQUEST";
export const GET_ENERGY_USAGE_PLAN_DESCRIPTION_SUCCESS =
  "@@site/GET_ENERGY_USAGE_PLAN_DESCRIPTION_SUCCESS";
export const GET_ENERGY_USAGE_PLAN_DESCRIPTION_FAILURE =
  "@@site/GET_ENERGY_USAGE_PLAN_DESCRIPTION_FAILURE";

export function getEnergyUsagePlanDescription(id, start) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_ENERGY_USAGE_PLAN_DESCRIPTION_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/site/${id}/energy-usage-plan?start=${start}&describe=true`,
      );
      dispatch({
        type: GET_ENERGY_USAGE_PLAN_DESCRIPTION_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_ENERGY_USAGE_PLAN_DESCRIPTION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_AMBER_SITE = "@@site/CLEAR_AMBER_SITE";

export function clearAmberSite() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_AMBER_SITE,
    });
  };
}

export const GET_AMBER_SITE_REQUEST = "@@site/GET_AMBER_SITE_REQUEST";
export const GET_AMBER_SITE_SUCCESS = "@@site/GET_AMBER_SITE_SUCCESS";
export const GET_AMBER_SITE_FAILURE = "@@site/GET_AMBER_SITE_FAILURE";

export function getAmberSite(id) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_AMBER_SITE_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/site/${id}/amber_site`);
      dispatch({
        type: GET_AMBER_SITE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_AMBER_SITE_FAILURE,
        payload: error,
      });
    }
  };
}

export const PUT_AMBER_SITE_REQUEST = "@@site/PUT_AMBER_SITE_REQUEST";
export const PUT_AMBER_SITE_SUCCESS = "@@site/PUT_AMBER_SITE_SUCCESS";
export const PUT_AMBER_SITE_FAILURE = "@@site/PUT_AMBER_SITE_FAILURE";

export function updateAmberSite(id, formData) {
  return async (dispatch) => {
    if (!id) return;

    dispatch({
      type: PUT_AMBER_SITE_REQUEST,
    });
    const init = {
      body: formData,
    };
    try {
      const response = await API.put("cmsAPI", `/site/${id}/amber_site`, init);
      dispatch({
        type: PUT_AMBER_SITE_SUCCESS,
        payload: response,
      });
      dispatch(getAmberSite(id));
    } catch (error) {
      dispatch({
        type: PUT_AMBER_SITE_FAILURE,
        payload: error,
      });
    }
  };
}

export const PUT_SITE_SALES_CHANNEL_REQUEST =
  "@@site/PUT_SITE_SALES_CHANNEL_REQUEST";
export const PUT_SITE_SALES_CHANNEL_SUCCESS =
  "@@site/PUT_SITE_SALES_CHANNEL_SUCCESS";
export const PUT_SITE_SALES_CHANNEL_FAILURE =
  "@@site/PUT_SITE_SALES_CHANNEL_FAILURE";

export function updateSiteSalesChannel(id, unitId, formData) {
  return async (dispatch) => {
    if (!id) return;

    dispatch({
      type: PUT_SITE_SALES_CHANNEL_REQUEST,
    });
    const init = {
      body: formData,
    };
    try {
      const response = await API.put("cmsAPI", `/site/${id}/sales`, init);
      dispatch({
        type: PUT_SITE_SALES_CHANNEL_SUCCESS,
        payload: response,
      });

      if (unitId) {
        dispatch(getUnitDetails(unitId));
      } else {
        dispatch(getSiteDetails(id));
      }
    } catch (error) {
      dispatch({
        type: PUT_SITE_SALES_CHANNEL_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SITE_STATUS_FILTER_LIST_REQUEST =
  "@@site/GET_SITE_STATUS_FILTER_LIST_REQUEST";
export const GET_SITE_STATUS_FILTER_LIST_SUCCESS =
  "@@site/GET_SITE_STATUS_FILTER_LIST_SUCCESS";
export const GET_SITE_STATUS_FILTER_LIST_FAILURE =
  "@@site/GET_SITE_STATUS_FILTER_LIST_FAILURE";

export function getSiteStatusFilterList(formData = undefined) {
  return async (dispatch) => {
    dispatch({
      type: GET_SITE_STATUS_FILTER_LIST_REQUEST,
    });
    try {
      let url = "/site/status";
      if (formData) {
        url = constructStatusQueryString(url, {
          ...formData,
          limit: formData?.view === SITE_VIEW.MAP ? null : formData.limit,
          offset: formData?.view === SITE_VIEW.MAP ? null : formData.offset,
          view: null,
        });
      }

      let response = await API.get("cmsAPI", url);

      // Ignore stale responses when search has changed since this request started
      const values = getDatatableFilters(SITE_FILTERS_KEY);
      if (!values || formData?.search === values?.search) {
        dispatch({
          type: GET_SITE_STATUS_FILTER_LIST_SUCCESS,
          payload: response,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_SITE_STATUS_FILTER_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SITE_OPERATION_LIST_REQUEST =
  "@@site/GET_SITE_OPERATION_LIST_REQUEST";
export const GET_SITE_OPERATION_LIST_SUCCESS =
  "@@site/GET_SITE_OPERATION_LIST_SUCCESS";
export const GET_SITE_OPERATION_LIST_FAILURE =
  "@@site/GET_SITE_OPERATION_LIST_FAILURE";

export function getSiteOperation(id, exclude_ended) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_SITE_OPERATION_LIST_REQUEST,
    });
    try {
      let url = `/site/${id}/operation?exclude_ended=${exclude_ended}`;
      const response = await API.get("cmsAPI", url);
      dispatch({
        type: GET_SITE_OPERATION_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_OPERATION_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const DELETE_SITE_OPERATION_REQUEST =
  "@@site/DELETE_SITE_OPERATION_REQUEST";
export const DELETE_SITE_OPERATION_SUCCESS =
  "@@site/DELETE_SITE_OPERATION_SUCCESS";
export const DELETE_SITE_OPERATION_FAILURE =
  "@@site/DELETE_SITE_OPERATION_FAILURE";

export function deleteSiteOperation(id, operationId, showRecentEnded) {
  return async (dispatch) => {
    dispatch({
      type: DELETE_SITE_OPERATION_REQUEST,
    });
    try {
      let url = `/site/${id}/operation/${operationId}`;
      const response = await API.del("cmsAPI", url);
      dispatch({
        type: DELETE_SITE_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(getSiteOperation(id, !showRecentEnded));

      return response;
    } catch (error) {
      dispatch({
        type: DELETE_SITE_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SITE_DEVICES_REQUEST = "@@site/GET_SITE_DEVICES_REQUEST";
export const GET_SITE_DEVICES_SUCCESS = "@@site/GET_SITE_DEVICES_SUCCESS";
export const GET_SITE_DEVICES_FAILURE = "@@site/GET_SITE_DEVICES_FAILURE";

export function getSiteDevices(id) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_SITE_DEVICES_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/site/${id}/device`);
      dispatch({
        type: GET_SITE_DEVICES_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_DEVICES_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_SITE_DEVICES = "@@site/CLEAR_SITE_DEVICES";

export function clearSiteDevices() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_SITE_DEVICES,
    });
  };
}

export const GET_SITE_STATUS_REQUEST = "@@site/GET_SITE_STATUS_REQUEST";
export const GET_SITE_STATUS_SUCCESS = "@@site/GET_SITE_STATUS_SUCCESS";
export const GET_SITE_STATUS_FAILURE = "@@site/GET_SITE_STATUS_FAILURE";

export function getSiteStatus(id) {
  return async (dispatch) => {
    dispatch({
      type: GET_SITE_STATUS_REQUEST,
    });
    try {
      let url = `/site/${id}/status`;
      const response = await API.get("cmsAPI", url);
      dispatch({
        type: GET_SITE_STATUS_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_STATUS_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_SITE_STATUS = "@@site/CLEAR_SITE_STATUS";

export function clearSiteStatus() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_SITE_STATUS,
    });
  };
}
